interface FormatProductCodesParams {
  code: string;
  referenceCode?: string;
}

export const formatProductCodes = ({ code, referenceCode }: FormatProductCodesParams) =>
  referenceCode ? `${code} (${referenceCode})` : code;
